<template>
  <div class="layout1">
    <div class="title">{{ title }}</div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "当日总用电",
    },
  },
};
</script>
<style lang="less" scoped>
.layout1 {
  padding-top: 26px;
  padding-left: 26px;
  box-sizing: border-box;
  background: #f8f8f9;
  width: 100%;
  height: 100%;
  border-radius: 7px;
  box-shadow: 0px 0px 13px rgba(32, 47, 79, 0.09);
  .title {
    font-size: 18px;
    color: #121c26;
    letter-spacing: 4px;
    font-weight: 600;
    text-align: left;
  }
}
@media screen and (max-width: 1440px) {
  .layout1 {
    padding-top: 12px;
    padding-left: 12px;
    .title {
      font-size: 12px;
    }
  }
}
</style>